export default "/corgi/pageapps/prepurchase/_next/static/media/energy-tag-range-old.7643e1d5.svg";